import { create } from "zustand";
import { BiteAttempt } from "../types/data";
import type { BiteType } from "@/features/notepad/constants/teaching";

type SupportModalState = {
  isOpen: boolean;
  studentName: string;
  lessonName: string;
  biteIndex: number;
  attempt: BiteAttempt | null;
  /** Property of the parent BITE, not the attempt. Carried here rather than
   *  stamped onto every attempt so there is one place it can be wrong. */
  biteType?: BiteType;
  openModal: (params: {
    studentName: string;
    lessonName: string;
    biteIndex: number;
    attempt: BiteAttempt;
    biteType?: BiteType;
  }) => void;
  closeModal: () => void;
};

export const useSupportModalStore = create<SupportModalState>((set) => ({
  isOpen: false,
  studentName: "",
  lessonName: "",
  biteIndex: 0,
  attempt: null,
  biteType: undefined,
  openModal: ({ studentName, lessonName, biteIndex, attempt, biteType }) =>
    set({
      isOpen: true,
      studentName,
      lessonName,
      biteIndex,
      attempt,
      biteType,
    }),
  closeModal: () =>
    set({
      isOpen: false,
      studentName: "",
      lessonName: "",
      biteIndex: 0,
      attempt: null,
      biteType: undefined,
    }),
}));
